export { CommandEventType, CommandName } from "@eyeo-fragments/in-product-messaging/background";
export var FragmentType;
(function (FragmentType) {
    FragmentType["legacy"] = "legacy";
    FragmentType["future"] = "future";
})(FragmentType || (FragmentType = {}));
export const featureFlagId = "ipm-use-future-fragment";
